import { FederationsService } from './../../../shared/services/federations/federations.service';
import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UiService } from 'app/shared/services/ui/ui.service';
import { Federation } from 'app/shared/models/class/federation/federation';

export interface DialogData {
  action: string;
  federation: Federation;
}

type switchOptions = {
  [key: string]: any
};

@Component({
  selector: 'app-open-dialog-add-edit-federation',
  templateUrl: './open-dialog-add-edit-federation.component.html',
  styleUrls: ['./open-dialog-add-edit-federation.component.scss']
})
export class OpenDialogAddEditFederationComponent implements OnInit {

  federationForm: UntypedFormGroup;
  title: string;
  btnConfirm: string;
  text: string;
  federation: Federation;

  constructor(
    private formBuilder: UntypedFormBuilder,
    public dialogRef: MatDialogRef<OpenDialogAddEditFederationComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private federationsSrv: FederationsService,
    private uiService: UiService
  ) { }

  ngOnInit(): void {
    this.initComponent();
    this.initForm();
  }

  onSubmit(): void {


    switch (this.data.action) {
      case 'add':
        let federation = new Federation(
          this.f.label.value,
          this.f.description.value
        )
        this.federationsSrv.addFederation(federation).subscribe({
          next: () => {
            this.uiService.showSnackbar('Fédération créée avec succès');
            this.dialogRef.close(true)
          }
        });

        break;
      case 'edit':
        this.federation = this.data.federation;
        this.federation.label = this.f.label.value;
        this.federation.description = this.f.description.value;

          this.federationsSrv.updateFederation(this.federation).subscribe({
            next: () => {
              this.uiService.showSnackbar('Fédération modifiée avec succès');
              this.dialogRef.close(true)
            }
          });


        break;

      default:
        break;
    }
  }

  private getLabel(type: string): string {
    const label: switchOptions = {
      add: {
        title: 'Ajouter une fédération',
        confirm: 'Ajouter',
        text: 'Fédération ajoutée'
      },
      edit: {
        title: 'Modifier la fédération',
        confirm: 'Mettre à jour',
        text: 'Fédération mise à jour',
      },
    };
    return label[this.data.action][type];
  }

  private initComponent(): void {

    this.title = this.getLabel('title');
    this.btnConfirm = this.getLabel('confirm');
    this.text = this.getLabel('text');
  }

  get f() {
    return this.federationForm.controls;
  }

  private initForm(): void {
    let label = '';
    let description = '';
    if (this.data.federation) {
      label = this.data.federation.label;
      description = this.data.federation.description;
    }
    this.federationForm = this.formBuilder.group({
      label: [label, Validators.required],
      description: [description],
    });
  }
}
